/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConsentDTO
 */
export interface ConsentDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    exportRestriction?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    recurringCard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    sendPostToCarePrincipal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    optOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    optIn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    readConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsentDTO
     */
    readConsentOptOut?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConsentDTO
     */
    reason?: string;
}

export function ConsentDTOFromJSON(json: any): ConsentDTO {
    return ConsentDTOFromJSONTyped(json, false);
}

export function ConsentDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsentDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exportRestriction': !exists(json, 'exportRestriction') ? undefined : json['exportRestriction'],
        'recurringCard': !exists(json, 'recurringCard') ? undefined : json['recurringCard'],
        'sendPostToCarePrincipal': !exists(json, 'sendPostToCarePrincipal') ? undefined : json['sendPostToCarePrincipal'],
        'optOut': !exists(json, 'optOut') ? undefined : json['optOut'],
        'optIn': !exists(json, 'optIn') ? undefined : json['optIn'],
        'readConsent': !exists(json, 'readConsent') ? undefined : json['readConsent'],
        'readConsentOptOut': !exists(json, 'readConsentOptOut') ? undefined : json['readConsentOptOut'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function ConsentDTOToJSON(value?: ConsentDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exportRestriction': value.exportRestriction,
        'recurringCard': value.recurringCard,
        'sendPostToCarePrincipal': value.sendPostToCarePrincipal,
        'optOut': value.optOut,
        'optIn': value.optIn,
        'readConsent': value.readConsent,
        'readConsentOptOut': value.readConsentOptOut,
        'reason': value.reason,
    };
}

